import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { ConditionalRender } from '../../../internal/components';
import BackDrop from '../../BackDrop';
import Portal from '../../Portal';
import DrawerBottomSheetContainer from './DrawerBottomSheetContainer';
import type {
  AnimatedDrawerBottomSheetContainerProps,
  DrawerBottomSheetProps,
} from './types';

const AnimatedDrawerBottomSheetContainer = forwardRef<
  HTMLDivElement,
  AnimatedDrawerBottomSheetContainerProps
>(({ fullHeight, state, transitionDuration, children, sx }, ref) => {
  return (
    <DrawerBottomSheetContainer
      state={state}
      transitionDuration={`${transitionDuration}ms`}
      fullHeight={fullHeight}
      sx={sx}
      ref={ref}
    >
      {children}
    </DrawerBottomSheetContainer>
  );
});

const DrawerBottomSheet = forwardRef<HTMLDivElement, DrawerBottomSheetProps>(
  (
    {
      sx,
      children,
      rootElement,
      onBackdropClick = () => {},
      fullHeight = false,
      state,
      transitionDuration,
      backDrop = (
        <BackDrop onClick={onBackdropClick} open={state !== 'closed'} />
      ),
      ...rest
    },
    ref
  ) => {
    return (
      <Portal rootElement={rootElement}>
        <div {...rest}>
          <ConditionalRender condition={state !== 'closed'}>
            {backDrop}
            <AnimatedDrawerBottomSheetContainer
              fullHeight={fullHeight}
              state={state}
              transitionDuration={transitionDuration}
              sx={sx}
              ref={ref}
            >
              {children}
            </AnimatedDrawerBottomSheetContainer>
          </ConditionalRender>
        </div>
      </Portal>
    );
  }
);

DrawerBottomSheet.propTypes = {
  /** the onDismiss function. */
  onBackdropClick: PropTypes.func,
  /** DrawerBottomSheet.Content */
  children: PropTypes.node,
  /** Whether the drawer is 100% of the screen height */
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
};

export default DrawerBottomSheet;
